import { render, staticRenderFns } from "./ResetLogin.vue?vue&type=template&id=0813de3c&"
import script from "./ResetLogin.vue?vue&type=script&lang=js&"
export * from "./ResetLogin.vue?vue&type=script&lang=js&"
import style0 from "./ResetLogin.vue?vue&type=style&index=0&id=0813de3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports